import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/home/runner/work/commerce-php/commerce-php/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const InlineAlert = makeShortcode("InlineAlert");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <p>{`Magento\\ResourceConnections module adds a mechanism to segregate database connections between master and slave
database servers based on the request type.`}</p>
    <p>{`For each master database connection (except the indexer connection) that are configured in db/connection section
of app/etc/env.php you can add one slave connection that can be configured in db/slave_connection.
Configuration format is the same as db/connection. Slave connection name must be the same as associated master
connection name. To enable slave connections for specific resources create a slave connection configuration
by adding slave_connection node as below:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-php"
      }}>{`<?php
return array (
    //...
    'db' =>
        array (
            'connection' =>
                array (
                    'default' =>
                        array (
                            'host' => 'default-master-host',
                            'dbname' => 'magento',
                            'username' => 'magento',
                            'password' => 'magento',
                            'active' => '1',
                        ),
                ),
            'slave_connection' =>
                array (
                    'default' =>
                        array (
                            'host' => 'default-slave-host',
                            'dbname' => 'magento',
                            'username' => 'read_only',
                            'password' => 'password',
                            'active' => '1',
                ),
        ),
        'table_prefix' => '',
    ),
    //.......
`}</code></pre>
    <p>{`To add slave connection for resources other than 'default' repeat the step and add to db/slave_connection
new element with same name and slave configuration for specified resource.
Config structure retains backward compatibility if module is turned off.`}</p>
    <p>{`WARNING: 'indexer' connection is not designed to have slave configuration.`}</p>
    <InlineAlert slots="text" mdxType="InlineAlert" />
The version of this module is 100.4.4.

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      